export class CountryModel {
  countryId: number = 0;
  code: string = "";
  name: string = "";
}
